module.exports = __webpack_public_path__ + "static/slide2.6f018b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide2.jpg
// module id = 1704
// module chunks = 173894859265406